import { create } from '@bufbuild/protobuf';
import { ProtobufClient } from 'api/protobuf/protobuf-client';
import { goBackendApi } from 'hooks/api/httpApi';
import { PackageProviderFeatureRequestSchema } from '../../../pb/requests/v1/package_provider_feature_request_pb';

type RequestPackageProviderFeatureParams = {
    provider: string;
    countryCode: string;
    hasAccess: boolean;
    description?: string;
};

export const requestPackageProviderFeatureMutation = ({
    provider,
    countryCode,
    hasAccess,
    description,
}: RequestPackageProviderFeatureParams) => {
    const pbClient = new ProtobufClient(goBackendApi());
    return pbClient.postRequest(
        PackageProviderFeatureRequestSchema,
        PackageProviderFeatureRequestSchema,
        '/api/v1/package-provider-features/request',
        create(PackageProviderFeatureRequestSchema, {
            provider,
            countryCode,
            hasAccess,
            description: description || undefined,
        })
    );
};
